export default () =>
  import(
    /* webpackChunkName: 'coffee/app/invite-new-user' */ './InviteNewUser'
  );
